<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
          <template v-slot:body>
            <b-row>
              <b-col lg="12" sm="12" class="form-for-textarea">
                <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                  <b-form  @submit.prevent="handleSubmit(saveData)" @reset.prevent="reset">
                    <b-overlay :show="unitLoad">
                      <b-row>
                        <b-col xl="7" lg="7" sm="12">
                          <b-row>
                              <b-col xl="6" lg="6" sm="12">
                                  <label label-cols-sm="4"><strong>{{ $t('grant_registration.institution_name') }}</strong></label>
                              </b-col>
                              <b-col xl="6" lg="6" sm="12">
                                  <label label-cols-sm="4">{{ (currentLocale === 'en') ? dataArray.ins_name : dataArray.ins_name_bn }}</label>
                              </b-col>
                          </b-row>
                          <b-row>
                              <b-col xl="6" lg="6" sm="12">
                                  <label label-cols-sm="4"><strong>{{ $t('externalUser.institution_registration_no') }}</strong></label>
                              </b-col>
                              <b-col xl="6" lg="6" sm="12">
                                  <label label-cols-sm="4">{{ dataArray.reg_no }}</label>
                              </b-col>
                          </b-row>
                        </b-col>
                        <b-col xl="5" lg="5" sm="12">
                          <b-row>
                              <b-col xl="6" lg="6" sm="12">
                                  <label label-cols-sm="4"><strong>{{ $t('externalUser.application_type') }}</strong></label>
                              </b-col>
                              <b-col xl="6" lg="6" sm="12">
                                  <label label-cols-sm="4">{{ (currentLocale === 'en') ? dataArray.application_type_en : dataArray.application_type_bn }}</label>
                              </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                      <br>
                      <b-table-simple bordered small>
                        <tbody>
                          <b-tr v-if="dataArray.application_type == 2">
                              <b-th width="50%" class="bg-primary">{{ $t('externalUser.capitation_grant_received') }}</b-th>
                              <b-td>
                                {{ $n(dataArray.grant_received) }}
                              </b-td>
                          </b-tr>
                          <b-tr v-if="dataArray.application_type == 2">
                              <b-th class="bg-primary">{{ $t('externalUser.extension_request_no') }}</b-th>
                              <b-td>
                                {{ $n(dataArray.extension_req_no) }}
                              </b-td>
                          </b-tr>
                          <b-tr v-if="dataArray.application_type == 1">
                              <b-th class="bg-primary">{{ $t('externalUser.grant_application_no') }}</b-th>
                              <b-td>
                                {{ $n(dataArray.grant_application_no) }}
                              </b-td>
                          </b-tr>
                          <b-tr>
                              <b-th class="bg-warning">{{ $t('grant_registration.approve_qty') }}</b-th>
                              <b-td>
                                  <ValidationProvider name="Approve Quantity" :rules="'required|min_value:1|max_value:' + (dataArray.application_type == 1 ? dataArray.grant_application_no : dataArray.extension_req_no)">
                                      <b-form-group
                                        class="m-0"
                                        slot-scope="{ valid, errors }"
                                      >
                                          <b-form-input
                                            type="number"
                                            v-model="dataArray.approve_qty"
                                            @input="changeTotal(dataArray)"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                          ></b-form-input>
                                          <div class="invalid-feedback">
                                            {{ errors[0] }}
                                          </div>
                                      </b-form-group>
                                  </ValidationProvider>
                              </b-td>
                          </b-tr>
                          <b-tr>
                              <b-th class="bg-gray">{{ $t('grant_registration.total_approve_qty') }}</b-th>
                              <b-td>{{ dataArray.total_received ? $n(dataArray.total_received) : $n(0) }}</b-td>
                          </b-tr>
                          </tbody>
                      </b-table-simple>
                      <div class="row">
                        <div class="col-sm-3"></div>
                        <div class="col text-right">
                            <b-button type="submit" variant="primary" class="mr-2">{{ saveBtnName }}</b-button>
                            &nbsp;
                            <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-approve')">{{ $t('globalTrans.cancel') }}</b-button>
                        </div>
                      </div>
                    </b-overlay>
                  </b-form>
                </ValidationObserver>
              </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { core } from '@/config/pluginInit'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { grantAllowanceServiceBaseUrl } from '@/config/api_config'
import { applicationApproveArchiveApi } from '../../api/routes'
import ConfirmationPopup from '@/Utils/confirmation-message'

export default {
  props: ['id'],
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
      saveBtnName: this.$t('globalTrans.approve'),
      dataArray: {
        approve_qty: '',
        total_received: 0
      },
      unitLoad: false
    }
  },
  computed: {
    currentLocale: function () {
        return this.$i18n.locale
    }
  },
  created () {
    if (this.id) {
      const tmp = this.getApplicationFormData()
      this.dataArray = tmp
    }
  },
  mounted () {
    core.index()
  },
  methods: {
    getApplicationFormData () {
        const tmpData = this.$store.state.list.find(item => item.id === this.id)
        return tmpData === undefined ? {} : JSON.parse(JSON.stringify(tmpData))
    },
    changeTotal (item) {
      if (parseInt(item.application_type) === 1) {
        item.total_received = parseInt(item.approve_qty)
      } else {
        item.total_received = parseInt(item.approve_qty) + parseInt(item.grant_received)
      }
    },
    saveData () {
      const Mydata = {
          id: this.id,
          approve_qty: parseInt(this.dataArray.approve_qty),
          total_received: this.dataArray.total_received,
          status: 2
      }
      var message = window.vm.$t('globalTrans.approveMsg')
      ConfirmationPopup(message, (response) => {
        if (response === true) {
          this.unitLoad = true
          this.$store.dispatch('mutateCommonProperties', { loading: true })
          const loadingState = { loading: false, listReload: true }
          RestApi.postData(grantAllowanceServiceBaseUrl, applicationApproveArchiveApi, Mydata).then(response => {
          this.$store.dispatch('mutateCommonProperties', loadingState)
              if (response.success) {
                  const notification = response.notification
                  if (notification && this.$store.state.emitNotification) {
                    this.$socket.emit('send-notification', notification)
                  }
                  this.$toast.success({
                      title: this.$t('globalTrans.success'),
                      message: this.$t('globalTrans.update_msg'),
                      color: '#D6E09B'
                  })
                  this.$bvModal.hide('modal-approve')
                  this.$bvModal.hide('modal-2')
              } else {
                  this.$toast.error({
                      title: this.$t('globalTrans.error'),
                      message: this.$t('globalTrans.operationFailed')
                  })
              }
              this.unitLoad = false
          })
        }
      })
    }
  }
}
</script>
